exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".record-query[data-v-6247315e] {\n  margin-bottom: 12px;\n}\n.record-pagination[data-v-6247315e] {\n  margin-top: 16px;\n  text-align: right;\n}\n", ""]);

// exports
